function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { composeDataMethods } from "@lululemon/mwa-utils";
import context from "./context";
import createProfileManager from "./manager";
// HOC
function withProfile() {
    var withProfileFactory = // HOC Factory
    function withProfileFactory(Component) {
        // Wrapping Component
        function WithProfile(props) {
            var manager = useMemo(function() {
                var result = typeof window !== "undefined" ? window.__LAPEL_PROFILE_MANAGER__ // eslint-disable-line
                 : null;
                return result || createProfileManager();
            }, []);
            return /*#__PURE__*/ _jsx(context.Provider, {
                value: manager,
                children: /*#__PURE__*/ _jsx(Component, _extends({}, props))
            });
        }
        return composeDataMethods(Component)(WithProfile);
    };
    return withProfileFactory;
}
export default withProfile;

//# sourceMappingURL=with-profile.js.map